import {ActiveContent} from "../../../redux/slices/content/contentType";
import {CharacterCreateMask} from "./CharacterCreateMask";
import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {RootState} from "../../../redux/store";
import {KampagneMask} from "./KampagneMask";
import {useQuery} from "@apollo/client";
import {GetCharacter4User} from "../../../GraphQL/CharacterQueries";
import {setCharacter} from "../../../redux/slices/character/characterSlice";
import {emptyCharacter} from "../../../Helper/Constants";

export const KampagneOverview = () => {
    const user = useAppSelector((state: RootState) => state.user);
    const adventure = useAppSelector((state: RootState) => state.adventure);
    const character = useAppSelector((state: RootState) => state.character);
    const content = useAppSelector((state: RootState) => state.content);
    const dispatch = useAppDispatch();

    const {
        data: characterData,
        error: characterError,
        loading: characterLoading
    } = useQuery(GetCharacter4User, {
        variables: {
            userId: Number(user.userId),
            adventureId: Number(adventure.adventureId)
        },
        skip: content.activeContent !== ActiveContent.KampagnePlay,
        fetchPolicy: 'network-only'
    })

    useEffect(() => {
        if (characterData && !characterLoading) {
            if (characterData.getCharacters4User) {
                dispatch(setCharacter({
                    characterName: characterData.getCharacters4User.characterName,
                    characterId: Number(characterData.getCharacters4User.characterId),
                    characterLevel: characterData.getCharacters4User.characterLevel,
                    characterExp: characterData.getCharacters4User.characterExp,
                    character_to_class: characterData.getCharacters4User.character_to_class,
                    Race: characterData.getCharacters4User.Race,
                    Subrace: characterData.getCharacters4User.Subrace,
                    CharacterSheet: characterData.getCharacters4User.CharacterSheet
                }))
            } else {
                dispatch(setCharacter(emptyCharacter));
            }
        }
    }, [ characterData ])

    return (
        <div
            className={content.activeContent === ActiveContent.KampagnePlay ? 'kampagne-container' : 'characterSheet-container mt-3'}>
            { !characterLoading && (
                <>
                    {character.characterId === 0 && (
                        <CharacterCreateMask/>
                    )}
                    {character.characterId > 0 && (
                        <>
                            <KampagneMask/>
                        </>
                    )}
                </>
            ) }

        </div>
    )
}